/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_SubtitleInputs */



/**
* | output |
* | --- |
* | "The integrations you can use, and your own settings for each. Switching one off silences its tools for you only — it never changes what your organization all..." |
*
* @param {My_Integrations_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_subtitle = /** @type {((inputs?: My_Integrations_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Integrationen, die Sie nutzen können, mit Ihren persönlichen Einstellungen. Eine abzuschalten deaktiviert deren Tools nur für Sie — an den Freigaben Ihrer Organisation ändert das nichts.")
	return /** @type {LocalizedString} */ ("The integrations you can use, and your own settings for each. Switching one off silences its tools for you only — it never changes what your organization allows.")
});